import styled from 'styled-components'

const StepButtonSubTextUi = styled.span`
  font-size: 12px;
  opacity: 0.8;
`

export default StepButtonSubTextUi
